import { createFileRoute } from '@tanstack/react-router';
import { CalendarClockIcon } from 'lucide-react';
import { useState } from 'react';

import { FillScreen, HStack, VStack } from '@/components/Layout';
import type { TabWithIndicatorProps } from '@/components/Navigation/HeaderTabs';
import { ProductHeader } from '@/components/ProductHeader';
import { Separator } from '@/components/ui/separator';
import {
  PackageSidebar,
  type SidebarState,
} from '@/features/operation-package/PackageSidebar';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { useTranslation } from '@/lib/i18n';

import { MockContent } from './planning-operations-core/-components/MockContent';

export const Route = createFileRoute('/_stacktrace/planning-operations-core')({
  component: PlanningOperationsCorePage,
});

const SIDEBAR_GROUPS = [
  {
    packages: [
      { id: 'release-plan-creation', label: 'リリースプラン作成' },
      { id: 'release-judgement', label: 'リリース判定' },
      { id: 'development-ticket-inventory', label: '開発チケット棚卸し' },
    ],
  },
];

function PlanningOperationsCoreLogo({ size = 40 }: { size?: number }) {
  return <CalendarClockIcon size={size} className="text-primary-on-fill" />;
}

function PlanningOperationsCorePage() {
  const { t } = useTranslation();
  const title = t('component.sidebar.pnForcePlanningOperationsCore');
  useDocumentTitle(title);

  const [activeId, setActiveId] = useState<string>(
    SIDEBAR_GROUPS[0].packages[0].id,
  );
  const [sidebarState, setSidebarState] = useState<SidebarState>('open');

  const activeLabel =
    SIDEBAR_GROUPS.flatMap((group) => group.packages).find(
      (item) => item.id === activeId,
    )?.label ?? '';

  const tabs: TabWithIndicatorProps[] = [
    {
      to: '/planning-operations-core' as const,
      children: 'オペレーションパッケージ',
      activeOptions: { exact: true, includeSearch: true },
    },
    {
      to: '/planning-operations-core/archives' as never,
      children: 'アーカイブ',
      disabled: true,
      activeOptions: { exact: true },
    },
    {
      to: '/planning-operations-core/configs' as never,
      children: '設定',
      disabled: true,
      activeOptions: { exact: true },
    },
  ];

  return (
    <VStack className="h-full">
      <ProductHeader
        Logo={PlanningOperationsCoreLogo}
        name={title}
        tabs={tabs}
        type="core"
      />
      <FillScreen>
        <HStack className="h-full w-full max-w-screen">
          <PackageSidebar
            groups={[...SIDEBAR_GROUPS]}
            activeId={activeId}
            onSelect={setActiveId}
            sidebarState={sidebarState}
            onStateChange={setSidebarState}
          />
          <Separator orientation="vertical" />
          <MockContent activeLabel={activeLabel} />
        </HStack>
      </FillScreen>
    </VStack>
  );
}
